import { Stack } from '@mui/material';
import { styled } from 'styled-components';

export const Container = styled(Stack)<{ $isLayout?: boolean; $fullHeight?: boolean }>`
    justify-content: center;
    align-items: center;
    width: 100%;

    ${({ $fullHeight, $isLayout }) => {
        if ($fullHeight) {
            return `height: calc(100vh - ${$isLayout ? '154px' : '112px'});`;
        } else {
            return `height: initial;`;
        }
    }}
`;
